import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../constant/api";
import axios from "axios";
import ReviewCard from "../../components/ReviewCard/ReviewCard";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import MyOrderProductCard from "../../components/Orders/MyOrderProductCard";
import SearchInput from "../../components/Home/SearchInput/SearchInput";

// Reusable Radio Button Component
const RadioButton = ({ name, value, checked, onChange, label }) => (
    <label className="flex items-center gap-2">
        <input
            type="radio"
            name={name}
            value={value}
            checked={checked}
            onChange={() => onChange(value)}
            className="hidden"
        />
        <span
            className={`transition ease-in-out duration-500 w-5 h-5 rounded-full border-2 ${checked ? "bg-white border-green-500" : "bg-white border-gray-400"} flex items-center justify-center`}
        >
            <span className={`transition ease-in-out duration-500 w-3 h-3 rounded-full ${checked ? "bg-brand-primary" : "bg-transparent"}`}></span>
        </span>
        {label}
    </label>
);

// Reusable Checkbox Button Component
const CheckboxButton = ({ checked, onChange, star }) => (
    <label key={star} className="flex items-center gap-2">
        <input
            type="checkbox"
            checked={checked}
            onChange={() => onChange(star)}
            className="hidden"
        />
        <span
            className={`transition ease-in-out duration-500 w-5 h-5 rounded-full border-2 ${checked ? "bg-white border-green-500" : "bg-white border-gray-400"} flex items-center justify-center`}
        >
            <span className={`transition ease-in-out duration-500 w-3 h-3 rounded-full ${checked ? "bg-brand-primary" : "bg-transparent"}`}></span>
        </span>
        {star} Star Rating
    </label>
);

function Reviews() {
    const { productId } = useParams();
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sortOption, setSortOption] = useState("mostRecent");
    const [filterStars, setFilterStars] = useState([]);
    const [topSellingProducts, setTopSellingProduct] = useState([]);
    const [trendingProduct, setTrendingProducts] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const totalStars = 5;

    // Function to render stars based on the rating
    const renderStars = (rating) => {
        const filledStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.5;
        const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0);

        return (
            <>
                {[...Array(filledStars)].map((_, index) => (
                    <FaStar key={`filled-${index}`} className="h-5 w-5 text-yellow-500" />
                ))}
                {hasHalfStar && <FaStarHalfAlt className="h-5 w-5 text-yellow-500" />}
                {[...Array(emptyStars)].map((_, index) => (
                    <FaRegStar key={`empty-${index}`} className="h-5 w-5 text-gray-400" />
                ))}
            </>
        );
    };

    // Fetch reviews from the API
    useEffect(() => {
        const fetchReviews = async () => {
            setLoading(true);
            try {
                const response = await axios.get(
                    `${BASE_URL}/products/reviews/${productId}/`
                );
                setReviews(response.data.Data || []);
                console.log(response.data.Data[0]);
            } catch (err) {
                console.error("Error fetching reviews", err);
            } finally {
                setLoading(false);
            }
        };

        fetchReviews();
    }, [productId]);

    // Function to handle sorting
    const handleSort = (option) => {
        setSortOption(option);
        const sortedReviews = [...reviews];
        if (option === "highestRating") {
            sortedReviews.sort((a, b) => b.rating - a.rating);
        } else if (option === "lowestRating") {
            sortedReviews.sort((a, b) => a.rating - b.rating);
        } else {
            sortedReviews.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        }
        setReviews(sortedReviews);
    };


    const fetchData = async (url, setter) => {
        try {
            const response = await axios.get(url);
            console.log(url, response)
            const data = response.data.Data || response.data.data;
            if (data) {
                setter(data);
            }

        } catch (error) {
            console.error(`Error fetching data from ${url}:`, error);
            const errorMessage = error.response?.data?.message || "Failed to fetch data";
            console.log("Fetch data error message:", errorMessage);
        }
    };


    useEffect(() => {
        fetchData(`${BASE_URL}/products/fast-moving/`, setTopSellingProduct); // not this
        fetchData(`${BASE_URL}/products/trending/`, setTrendingProducts); // not this
    }, []);


    // Function to handle filtering
    const handleFilter = (star) => {
        const updatedFilter = filterStars.includes(star)
            ? filterStars.filter((s) => s !== star)
            : [...filterStars, star];
        setFilterStars(updatedFilter);
    };

    // Apply filters and search
    const filteredReviews = reviews
        .filter((review) =>
            filterStars.length > 0 ? filterStars.includes(Math.floor(review.rating)) : true
        )
        .filter((review) =>
            review.comments.toLowerCase().includes(searchQuery)
        );

    // Function to handle search input change
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());

    };


    return (

        <>
            <SearchInput
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder="Search reviews..."
                head="Reviews"
            />

            <div className="p-4 flex flex-col lg:flex-row gap-10">
                {/* Left side - Sorting and Filters */}
                <div className="flex flex-row text-base lg:flex-col w-full lg:w-1/6 gap-4">
                    <div className="flex-1 lg:flex-none">
                        <h3 className="font-bold text-lg">Sort</h3>
                        <div className="flex flex-col border-2 rounded-lg p-2 gap-2">
                            <RadioButton
                                name="sort"
                                value="mostRecent"
                                checked={sortOption === "mostRecent"}
                                onChange={handleSort}
                                label="Most Recent"
                            />
                            <RadioButton
                                name="sort"
                                value="highestRating"
                                checked={sortOption === "highestRating"}
                                onChange={handleSort}
                                label="Highest Rating"
                            />
                            <RadioButton
                                name="sort"
                                value="lowestRating"
                                checked={sortOption === "lowestRating"}
                                onChange={handleSort}
                                label="Lowest Rating"
                            />
                        </div>
                    </div>

                    <div className="flex-1 lg:flex-none">
                        <h3 className="font-bold text-lg">Filters</h3>
                        <div className="flex flex-col border-2 rounded-lg p-2 gap-2">
                            {[5, 4, 3, 2, 1].map((star) => (
                                <CheckboxButton
                                    key={star}
                                    checked={filterStars.includes(star)}
                                    onChange={handleFilter}
                                    star={star}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="flex-1 hidden lg:block lg:flex-none">
                        {/*  Trending Products */}
                        <div className="col-span-1">
                            <MyOrderProductCard
                                products={topSellingProducts}
                                title="Top Selling Products"
                                layout="vertical-3-scroll"
                            />
                        </div>
                    </div>
                </div>


                {/* Main center - Reviews */}
                <div className="mb-4 w-full lg:w-4/6">
                    {loading ? (
                        <p>Loading reviews...</p>
                    ) : filteredReviews.length > 0 ? (
                        filteredReviews.map((review, index) => (
                            <ReviewCard
                                key={index}
                                review={review}
                                renderStars={renderStars}
                            />
                        ))
                    ) : (
                        <p>No reviews found.</p>
                    )}
                </div>

                {/* Right side - Additional Info */}
                <div className="w-full lg:w-2/6">
                    {/*  Trending Products */}
                    <div className="col-span-1">
                        <MyOrderProductCard
                            products={trendingProduct}
                            title="Trending Products"
                            layout={`vertical-3-horizontal-2`}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Reviews;
